var _g, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInnvoLockupCream(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 120",
    role: "img",
    "aria-label": "Innvo Labs lockup",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,28)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#F4EFE6",
    strokeWidth: 7,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 46,
    x2: 16,
    y2: 54
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 36,
    x2: 28,
    y2: 64
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 30,
    x2: 52,
    y2: 62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: 40,
    x2: 64,
    y2: 56
  })), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 22,
    x2: 40,
    y2: 58,
    stroke: "#C0218F",
    strokeWidth: 7,
    strokeLinecap: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 78,
    fontFamily: "Geist, Inter, system-ui, sans-serif",
    fontWeight: 700,
    fontSize: 64,
    letterSpacing: -4,
    fill: "#F4EFE6"
  }, "innvo")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 124,
    y: 100,
    fontFamily: "JetBrains Mono, monospace",
    fontWeight: 500,
    fontSize: 11,
    letterSpacing: 4,
    fill: "rgba(244,239,230,0.6)"
  }, "\u2014 LABS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnvoLockupCream);
export default __webpack_public_path__ + "static/media/innvo-lockup-cream.ede64ad9c7a904b8a23725ba210e6b0e.svg";
export { ForwardRef as ReactComponent };